function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5659 1.92351L12.662 3.79028C12.3132 4.1323 12.3117 4.68709 12.6586 5.03097L14.9391 7.29166C15.2895 7.63901 15.8611 7.63847 16.2108 7.29047L18.075 5.43545C18.4166 5.09548 18.4193 4.5496 18.0809 4.20647L15.84 1.93404C15.4927 1.58182 14.9192 1.57708 14.5659 1.92351ZM15.187 3.79698L16.1878 4.812L15.5734 5.42365L14.5564 4.41566L15.187 3.79698Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8765 5.82459L1.93179 14.5249C1.7621 14.69 1.66663 14.9148 1.66663 15.1494V17.4546C1.66663 17.94 2.06707 18.3334 2.56105 18.3334H4.56281C4.79529 18.3334 5.01863 18.2445 5.18552 18.0854L14.3211 9.37997C14.6713 9.04622 14.6847 8.49824 14.3512 8.14836L12.1585 5.84836C11.8142 5.48718 11.2344 5.47643 10.8765 5.82459ZM11.4815 7.70853L12.4448 8.71916L4.19993 16.5757H3.45577V15.515L11.4815 7.70853Z",
  fill: "currentColor"
});

function SvgCambiar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCambiar);
export default __webpack_public_path__ + "static/media/cambiar.7d1bd1d2.svg";
export { ForwardRef as ReactComponent };